import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { RouterModule } from "@angular/router";
import { NgSpinBoxModule } from "@app/_shared/directives";
import { NumberOnlyModule } from "@app/_shared/directives/number-only/number-only.module";
import { LocaleConverterModule, NullCheckModule, TruncateStringModule } from "@app/_shared/pipes";
import { EarningsFormatterModule } from "@app/_shared/pipes/earnings-formatter/earnings-formatter.module";
import { UnitFormatterModule } from "@app/_shared/pipes/locale-formatter/locale-formatter.module";
import { TooltipModule } from "@app/_shared/directives/tooltip/tooltip.module";
import { MatLegacyChipsModule as MatChipsModule } from "@angular/material/legacy-chips";
import { CustomToasterComponent } from "./custom-toaster.component";
import { MbPlansModule } from "@app/modules/trading/modules/mb-plans/mb-plans.module";

@NgModule({
  declarations: [
    CustomToasterComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    NullCheckModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    LocaleConverterModule,
    NumberOnlyModule,
    NgSpinBoxModule,
    TruncateStringModule,
    MatTooltipModule,
    UnitFormatterModule,
    EarningsFormatterModule,
    TooltipModule,
    MatChipsModule,
    MbPlansModule,
  ],
  exports: [
    CustomToasterComponent
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: undefined },
    { provide: MatDialogRef, useValue: {} }
  ]
})
export class CustomToasterModule { }
